import type { Form } from '@formily/core';

/**
 * Template-resolution context of a Formily form: the `context` and
 * `parentContext` it was created with (see `FormilyForm`).
 */
export const getFormContext = (form: Form): Record<string, any> => {
  const { context, parentContext } = form.props as any;
  return { ...context, ...parentContext };
};
